"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.secDocs = void 0;
var secDocs = {
  name: 'sec',
  category: 'Trigonometry',
  syntax: ['sec(x)'],
  description: 'Compute the secant of x in radians. Defined as 1/cos(x)',
  examples: ['sec(2)', '1 / cos(2)'],
  seealso: ['cot', 'csc', 'cos']
};
exports.secDocs = secDocs;